import React from "react";
import "./Introduction.css";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import { ThemeContext } from "../../Context/theme";
import mypic from "../../Assets/Requird-image/mypic.png"
import StarRateIcon from "@material-ui/icons/StarRate";

export const Introduction = () => {
  const [{ themename }] = React.useContext(ThemeContext);

  return (
    <>
      <section id="#about">
        <div className="section" data-aos="fade-right">
          <h2 className="section__title">
            About
          </h2>
          <div className={"introduction " + themename}>
            <div className="introduction_logocontainer">
              <img
                src={mypic}
                alt="myimage"
              />
            </div>
            <div className="introduction_datacontainer">
              <h4>
                {/* Hi Everyone, I am{" "}
                <span className="different">Shilajit Paul</span> from{" "}
                <span className="different"> Chandannagar,WestBengal</span>. */}
                 {/* I have
                completed my postgraduate in MCA  from Academy of Technology, Adisaptagram,WestBengal. */}
                A passionate Full-Stack Web Developer and a JavaScript enthusiast who loves to create smart and highly polished
                interfaces for the web with hands on experience in designing, developing and maintaining projects. Highly skilled
                in
                collaboration, decision-making and Data structure & Algorithms.
                Looking forward to work on exciting projects that
                can help in making people's lives better and comfortable.
              </h4>
              {/* <h4>
                Some of my interests apart from Programming :
              </h4>
              <h4 className="different">
                <span className="icons">
                  <StarRateIcon />
                </span>
                Playing Chess{" "}
              </h4>
              <h4 className="different">
                <span className="icons">
                  <StarRateIcon />
                </span>
                Writing{" "}
              </h4>
              <h4 className="different">
                <span className="icons">
                  <StarRateIcon />
                </span>
                Singing{" "}
              </h4>
              <h4 className="different">
                <span className="icons">
                  <StarRateIcon />
                </span>
                Cooking{" "}
              </h4>
              <h4 className="different">
                <span className="icons">
                  <StarRateIcon />
                </span>
                Playing football{" "}
              </h4> */}
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
